/* ==================================================================
   North Shore Peptides — Generic scroll reveal
   Any element with [data-animate="true"] reveals its [class*="__item"]
   / [class$="__anim"] children when it scrolls into view.
   (Skips .np-hero, which has its own controller.)
   ================================================================== */
(function () {
  'use strict';

  function reveal(el) {
    if (el.dataset.npReveal === '1') return;
    el.dataset.npReveal = '1';
    if (el.dataset.animate !== 'true') return;

    // Always reveal in the theme editor so merchants see content
    if (window.Shopify && window.Shopify.designMode) { el.classList.add('is-in'); return; }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    io.observe(el);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-animate="true"]:not(.np-hero)').forEach(reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-animate="true"]:not(.np-hero)').forEach(function (el) {
      el.dataset.npReveal = '';
      el.classList.remove('is-in');
      reveal(el);
    });
  });
})();
